// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategorizeSettingManagementContent_main__H2e3Q {
    position: relative;
    width: 100%;
    height: 100%;
}

.CategorizeSettingManagementContent_header__\\+za-C {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    margin-bottom: 25px;
}

.CategorizeSettingManagementContent_back_butn__-XPPF {
    position: absolute;
    left: 0;
    top: 0;
}

.CategorizeSettingManagementContent_title__Oaoo4 {
    font-size: 30px;
}

/* .container {
    width: 100%;
    min-height: calc(100% - 60px);
    padding: 20px;
    border-radius: 6px;
    background-color: #ffffff;
} */

.CategorizeSettingManagementContent_form_box__ShhhB {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: calc(100% - 60px);
    padding: 20px;
    border-radius: 6px;
    background-color: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/CategorizeSettingManagementContent/index.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;AACV;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;;;GAMG;;AAEH;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B","sourcesContent":[".main {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.header {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 35px;\n    margin-bottom: 25px;\n}\n\n.back_butn {\n    position: absolute;\n    left: 0;\n    top: 0;\n}\n\n.title {\n    font-size: 30px;\n}\n\n/* .container {\n    width: 100%;\n    min-height: calc(100% - 60px);\n    padding: 20px;\n    border-radius: 6px;\n    background-color: #ffffff;\n} */\n\n.form_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    min-height: calc(100% - 60px);\n    padding: 20px;\n    border-radius: 6px;\n    background-color: #ffffff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `CategorizeSettingManagementContent_main__H2e3Q`,
	"header": `CategorizeSettingManagementContent_header__+za-C`,
	"back_butn": `CategorizeSettingManagementContent_back_butn__-XPPF`,
	"title": `CategorizeSettingManagementContent_title__Oaoo4`,
	"form_box": `CategorizeSettingManagementContent_form_box__ShhhB`
};
export default ___CSS_LOADER_EXPORT___;
